import { isBefore } from 'date-fns';
import * as Notifications from 'expo-notifications';
import React, { useEffect } from 'react';
import { StatusBar, StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';

import ContainerWidthLimit from './components/ContainerWidthLimit';
import { usePushNotificationContext } from './hooks/PushNotificationProvider';
import Routes from './routes';
import useSpaceManagement from '_/hooks/useSpaceManagement';
import { SafeAreaView } from 'react-native-safe-area-context';

// - MIGRATION -
const LIMITED_ACCESS_COMPANY_ID = '9501fedf-3f2f-4e9c-b20e-d8d39097f919';
// - MIGRATION -

export default function AppNavigator() {
  const { id: userId, currentCompanyId } = useSelector((state: any) => state.user);
  const waccessIntegration = useSelector((state: any) => state.company.waccessIntegration);
  const flowRestrictions = useSelector((state: any) => state.company.flowRestrictions);
  const spaceManagement = useSpaceManagement((state) => state.spaceManagement);
  const getSpaceManagement = useSpaceManagement((state) => state.getSpaceManagement);
  const hostSpaceManagementEnabled = useSelector((state: any) => state.host.spaceManagementEnabled);
  const auth = useSelector((state: any) => state.auth);
  const role = useSelector((state: any) => state.host.role);
  const activeCategory = useSelector((state: any) => state.host.activeCategory);

  const waccessIntegrationOnlyQRCode = useSelector(
    (state: any) => state.company.customization?.waccessIntegrationOnlyQRCode
  );

  const {
    trialUntil,
    planIsActive,
    id: companyId,
    disableQrcodeApp,
  } = useSelector((state: any) => state.company);
  const { handleNotification, verifyIfShouldShowModal, deviceIdRef } = usePushNotificationContext();

  useEffect(() => {
    const listener = Notifications.addNotificationResponseReceivedListener(handleNotification);

    // Cold start: app estava fechado quando tocou na notificação
    Notifications.getLastNotificationResponseAsync().then((response) => {
      if (response) {
        handleNotification(response);
      }
    });

    return () => {
      listener.remove();
    };
  }, [handleNotification]);

  useEffect(() => {
    if (currentCompanyId) {
      getSpaceManagement(currentCompanyId);
    }
  }, [currentCompanyId]);

  useEffect(() => {
    if (!userId) return;
    const timer = setTimeout(() => {
      if (deviceIdRef.current) {
        verifyIfShouldShowModal();
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [userId]);

  return (
    <SafeAreaView style={styles.container} edges={['left', 'right']}>
      <StatusBar barStyle="dark-content" translucent backgroundColor="transparent" />
      <ContainerWidthLimit>
        <Routes
          auth={{
            ...auth,
            role,
            companyId,
            spaceManagement,
            flowRestrictions,
            activeCategory,
            hostSpaceManagementEnabled,
            disableQrcodeApp,
          }}
          onlyDynamicQRCode={waccessIntegrationOnlyQRCode}
          expired={!planIsActive && isBefore(trialUntil, new Date())}
          showQRCodePagefirst={!!waccessIntegration?.aesKey}
          isAccessLimited={companyId === LIMITED_ACCESS_COMPANY_ID}
        />
      </ContainerWidthLimit>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'transparent',
  },
});
